import React from 'react';
import PropTypes from 'prop-types';

import modal from '../../components/modals/Modal.m.sass';

import Modal from './Modal';
import Button from '../button/Button';
import CartProduct from '../cartProduct/CartProduct';
import CartProductDetailed from '../cartProduct/CartProductDetailed';


export default function CartModal({items, onClose, onRemove, onCheckout, ...rest}) {
  return (
    <Modal cart onClose={onClose} {...rest}>
      <div className={modal.modal_header}>Shopping Cart</div>

      {items.length ? (
        <div className={modal.modal_productList}>
          {items.map(item =>
            <CartProductDetailed
              key={item.id}
              image={item.variant.product.images[0]}
              name={CartProduct.getItemTitle(item)}
              price={item.total}
              quantity={item.quantity}
              eventOccurrence={item.eventOccurrence}
              options={item.options}
              onRemoveClick={() => onRemove(item.id)}
            />
          )}
        </div>
      ) : (
        <div className={modal.modal_notice}>
          <p className={modal.modal_text}>Your cart is empty :( <br/> Buy something!</p>
        </div>
      )}

      <div className={modal.modal_btns}>
        <div className={modal.modal_btn}>
          <Button full gradient onClick={onClose}>Continue Shopping</Button>
        </div>

        {!!items.length && (
          <div className={modal.modal_btn}>
           <Button full onClick={onCheckout}>Checkout</Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

CartModal.propTypes = {
  items: PropTypes.array,
  onClose: PropTypes.func,
  onRemove: PropTypes.func,
  onCheckout: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/modals/CartModal.js